import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/Product.vue")
  },
  {
    path: "/product/:slug",
    name: "product-slug",
    component: () => import("../views/ProductSlug.vue")
  },
  {
    path: "/company-information",
    name: "company-information",
    component: () => import("../views/CompanyInformation.vue")
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("../views/NotFound.vue")
  },
  {
    path: "*",
    redirect: "/not-found"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
